import styled from 'styled-components';

export const StyledActiveFilters = styled.div`
  width: 100%;

  .active-filters {
    margin-bottom: 24px;
    padding: 16px;
    background: ${({ theme }) => theme.colors.athensGray};
    border-radius: 8px;
    border-left: 4px solid ${({ theme }) => theme.colors.mainOrange};

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;

      &__label {
        label {
          font-weight: 600;
        }
      }

      &__clear-all {
        background: none;
        border: none;
        color: ${({ theme }) => theme.colors.mainOrange};
        cursor: pointer;
        padding: 4px 8px;
        font-size: 13px;
        font-weight: 600;
        transition: opacity 0.3s ease;

        &:hover {
          opacity: 0.7;
        }
      }
    }

    &__chips {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      &__chip {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 12px;
        background: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.gallery};
        border-radius: 20px;
        transition: all 0.3s ease;

        &:hover {
          border-color: ${({ theme }) => theme.colors.mainOrange};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        &__label {
          label {
            display: flex;
            align-items: center;
            gap: 4px;
          }

          &__type {
            font-weight: 600;
            color: ${({ theme }) => theme.colors.mainOrange};
          }
        }

        &__remove {
          display: flex;
          align-items: center;
          justify-content: center;
          background: none;
          border: none;
          color: ${({ theme }) => theme.colors.raven};
          cursor: pointer;
          padding: 2px;
          font-size: 12px;
          transition: color 0.3s ease;

          &:hover {
            color: ${({ theme }) => theme.colors.mainOrange};
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .active-filters {
      padding: 12px;

      &__chips {
        gap: 6px;

        &__chip {
          padding: 5px 10px;
          font-size: 13px;
        }
      }
    }
  }
`;
